// Lista de empresas para vouchers corporativos
export const EMPRESAS_VOUCHER = [
  'COLEGIO DON BOSCO',
  'EMBAJADA BRITÁNICA'
];

// Lista de empresas para el menú principal (incluye Efectivo)
export const EMPRESAS_MENU_PRINCIPAL = [
  'Efectivo',
  ...EMPRESAS_VOUCHER
];
